module.exports = __webpack_public_path__ + "static/media/email.305aa3ba.svg";